<template>
  <b-row>
    <b-col cols="12">
      <h4 class="mb-4">{{language === 'de' ? 'Unsere Partner' : 'Our partners'}}</h4>
    </b-col>
    <b-col cols="12" md="6" lg="4" class="pb-4">
      <b-card no-body class="h-100 border-0 shadow-sm field__card">
        <b-card-header class="field__header">
          <div class="fs-5">AJEETS</div>
        </b-card-header>
        <b-card-body class="field__body bg-white">
          <div class="field__item">
            <p class="mb-2">
              <b-icon icon="geo-alt" class="me-2"></b-icon>A - 407, Western Edge 2, Borivali (East), Mumbai, 400066, Maharashtra, India
            </p>
            <b-icon icon="envelope" class="me-2"></b-icon><a href="mailto:cv@ajeets.com">cv@ajeets.com</a><br>
            <b-icon icon="telephone" class="me-2"></b-icon><a href="tel:+918645322462">+91 8645322462</a><br>
            <b-icon icon="whatsapp" class="me-2"></b-icon> <a target="_blank" href="https://wa.me/+91 9692553083">+91 9692553083</a><br>
            <b-icon icon="link" class="me-2"></b-icon><a target="_blank" href="https://ajeets.com">ajeets.com</a>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col cols="12" md="6" lg="4" class="pb-4">
      <b-card no-body class="h-100 border-0 shadow-sm field__card">
        <b-card-header class="field__header">
          <div class="fs-5">Transcura GmbH</div>
        </b-card-header>
        <b-card-body class="bg-white field__body" v-if="language === 'de'">
          <div class="field__item">
            <p class="mb-2">
              <b-icon icon="geo-alt" class="me-2"></b-icon>Franz-Sigel-Straße 21<br/>
              68753 Waghäusel
            </p>
            <b-icon icon="envelope" class="me-2"></b-icon><a href="mailto:info@transcura.de">info@transcura.de</a><br>
            <b-icon icon="telephone" class="me-2"></b-icon><a href="tel:+4962112185270">+49 621 121852-70</a><br>
            <b-icon icon="link" class="me-2"></b-icon><a target="_blank" href="https://transcura.de">transcura.de</a>
          </div>
        </b-card-body>
        <b-card-body class="bg-white field__body" v-else>
          <div class="field__item">
            <p class="mb-2">
              <b-icon icon="geo-alt" class="me-2"></b-icon>Franz-Sigel-Straße 21<br/>
              68753 Waghäusel<br/>
              Germany
            </p>
            <b-icon icon="envelope" class="me-2"></b-icon><a href="mailto:info@transcura.de">info@transcura.de</a><br>
            <b-icon icon="link" class="me-2"></b-icon><a target="_blank" href="https://transcura.de">transcura.de</a>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col cols="12" md="6" lg="4" class="pb-4">
      <b-card no-body class="h-100 border-0 shadow-sm field__card">
        <b-card-header class="field__header">
          <div class="fs-5">Jobnet.AG</div>
        </b-card-header>
        <b-card-body class="bg-white field__body"  v-if="language === 'de'">
          <div class="field__item">
            <p class="mb-2">
              <b-icon icon="geo-alt" class="me-2"></b-icon>Kolonnenstraße 8 <br />
              10827 Berlin
            </p>

            <b-icon icon="envelope" class="me-2"></b-icon><a href="mailto:kh@jobnet.solutions">kh@jobnet.solutions</a><br>
            <b-icon icon="link" class="me-2"></b-icon><a target="_blank" href="https://jobnet.international">jobnet.international</a></div>
        </b-card-body>
        <b-card-body class="bg-white field__body"  v-else>
          <div class="field__item">
            <p class="mb-2">
              <b-icon icon="geo-alt" class="me-2"></b-icon>Kolonnenstraße 8<br/>
              10827 Berlin<br/>
              Germany
            </p>

            <b-icon icon="envelope" class="me-2"></b-icon><a href="mailto:kh@jobnet.solutions">kh@jobnet.solutions</a><br>
            <b-icon icon="link" class="me-2"></b-icon><a target="_blank" href="https://jobnet.international">jobnet.international</a></div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component
export default class InformationEdunetin extends Vue {
  get language() {
    return AppModule.language;
  }
}
</script>
<style lang="scss" scoped>
</style>
